import asBentoPage from 'common/bento/hoc/asBentoPage';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import ComplianceApplicationProblem from '../../components/ComplianceApplicationProblem/ComplianceApplicationProblem';
import { ComplianceApplicationProblemReason } from '../../libs/constants';
import locales from './locales';

/**
 * A blocker page explaining to the user that we cannot open an account for them
 * if they are US citizens.
 */
const UsCitizenshipNotAllowed = asBentoPage(({ Layout }) => {
  return (
    <Layout data-testid="compliance-error" nav={<OBNavigation />}>
      <ComplianceApplicationProblem
        reason={ComplianceApplicationProblemReason.UsCitizenship}
        reasonText={locales.reason}
      />
    </Layout>
  );
});

export default UsCitizenshipNotAllowed;
